module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/eV0FVC/media/FC-9781398437289.jpg?1684514527477",
      "alt": "This image is the cover for the book Authentic Church"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Authentic Church\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("If you had a blank sheet of paper and were going to describe what church should look like, what would you include? Why has the make-up, of what we generally understand to be church, diverged so significantly from the kinds of people that Jesus hung out with? For very few of them would easily fit into most churches today. This book is an attempt to consider this and whether or not the Anglican parish system still has anything to offer by way of a way forwards as the numbers of those attending church in this country still continue to decline. This book attempts to describe our experience as members of St Paul’s Church here in Cambridge, as the theology that underlies it emerged in our midst on our journey together and as it is summarised so succinctly by Luke in Acts chapter 2 verse 42.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Michael Beckett\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Michael Beckett was born in Essex and married at the age of 21 to Debbie. They have four grown-up children who each have two children. They have lived half their lives in Cambridge following Michael’s ordination into the Church of England in 1988. He was vicar of St Paul’s Church in Cambridge for 28 years and retired in the year 2021. He already has one book published, The Gospel in Esther.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0